<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'window_energy_ratings' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <ng-container class="contentDiv">

      <!-- Configuration mode -->
      <div class="mode-card">
        <div class="select-group">
          <ion-label class="select-label">{{'rated_by' | translate}}:</ion-label>
          <ion-select [(ngModel)]="selectedCountry" interface="popover" class="styled-select" placeholder="{{ 'select' | translate }}" [interfaceOptions]="{ cssClass: 'rating-select-popover' }"
            (ionChange)="onCountryChange()">
            <ion-select-option *ngFor="let obj of countryData" [value]="obj.value">
              {{obj.displayName | translate}}
            </ion-select-option>
          </ion-select>
        </div>
      </div>

      <div class="form-container">
        <div class="select-group" *ngIf="selectedCountry=='Großbritannien'">
          <ion-label class="input-label">{{'air_leakage' | translate}}</ion-label>
          <ion-input class="bordered-input" type="number" inputmode="decimal" [(ngModel)]="airleakage" name="airleakage"
            min="0" max="2" step="0.01" (ionInput)="validateAirLeakage($event)">
          </ion-input>
        </div>

        <div class="select-group" *ngIf="selectedCountry=='Großbritannien'">
          <ion-label class="input-label">{{'opening_light' | translate}}</ion-label>
          <ion-input class="bordered-input" type="number" inputmode="decimal" [(ngModel)]="ool" name="ool" min="0"
            max="5" step="0.01" (ionInput)="validateOpeningLight($event)">
          </ion-input>
        </div>

        <div class="select-group" *ngIf="selectedCountry=='Großbritannien'">
          <ion-label class="input-label">{{'GASKET_PROTUSION' | translate}}</ion-label>
          <ion-input class="bordered-input" type="number" inputmode="decimal" [(ngModel)]="agWithoutGasket"
            name="agWithoutGasket" min="0" max="5" step="0.01" (ionInput)="validateGasket($event)">
          </ion-input>
        </div>

        <div class="select-group" *ngIf="selectedCountry=='Schweiz'" style="gap:0">
          <ion-label class="input-label">{{'window_type' | translate}}</ion-label>
          <ion-label class="text-label">{{'WINDOW_TYPE_DOUBLE_SASH' | translate}}<br>a=1.55 m - b=1.15 m</ion-label>
        </div>

        <div class="select-group" *ngIf="selectedCountry=='Frankreich'">
          <ion-label class="input-label">{{'window_type' | translate}}</ion-label>
          <ion-select [(ngModel)]="selectedFrWindowType" interface="popover" class="styled-select"
            (ionChange)="onWindowChange()">
            <ion-select-option *ngFor="let obj of frWindowTypes" [value]="obj.id.toString()">
              {{obj.name | translate}}
            </ion-select-option>
          </ion-select>
          <ion-label class="text-label" *ngIf="selectedFrWindowType=='13'">a=1.53 m - b=1.48 m</ion-label>
          <ion-label class="text-label" *ngIf="selectedFrWindowType=='14'">a=2.18 m - b=2.35 m</ion-label>
        </div>


        <div class="select-group" *ngIf="selectedCountry=='Other'">
          <ion-label class="input-label">{{'window_type' | translate}}</ion-label>
          <ion-select [(ngModel)]="selectedRatingWindowType" interface="popover" class="styled-select"
            (ionChange)="onWindowChange()">
            <ion-select-option *ngFor="let obj of otherWindowTypes" [value]="obj.id.toString()">
              {{obj.name | translate}}
            </ion-select-option>
          </ion-select>
          <ion-label class="text-label" *ngIf="selectedRatingWindowType=='1' || selectedRatingWindowType=='9'">a=1.23 m
            - b=1.48 m</ion-label>
        </div>

        <div class="select-group" *ngIf="selectedCountry=='Other'">
          <ion-label class="input-label">{{'CLIMATE_ZONE' | translate}}</ion-label>
          <ion-select [(ngModel)]="selClimateZone" interface="popover" class="styled-select"
            (ionChange)="onClimateZoneChange()">
            <ion-select-option *ngFor="let obj of climateZonesData" [value]="obj.value">
              {{obj.displayName | translate}}
            </ion-select-option>
          </ion-select>
        </div>
      </div>

      <div class="bordered-button" (click)="clickRequirements()" *ngIf="selectedCountry=='Other'">
        <!-- <ion-icon name="eye-outline"></ion-icon> -->
        <span>{{'requirements' | translate}}</span>
      </div>

      <ion-chip color="primary" class="customChip primaryClass" *ngIf="result">
        <ion-label>
          <div class="chip-content">
            <div class="chip-title">{{'results' | translate}}</div>
            <div class="chip-description" *ngIf="this.selectedCountry == 'Schweiz'">
              <ul>
                <li>Uw,eq: {{result.uweq}} W/m²K</li>
                <li>{{'EFFICIENCY_CLASSES' | translate}}: {{result.rating}} </li>
              </ul>
            </div>
            <div class="chip-description" *ngIf="this.selectedCountry == 'Dänemark'">
              <ul>
                <li>E<sub>ref</sub>: {{result.eref}} kWh/m²a</li>
                <li>{{'CLASS' | translate}}: {{result.werClass}}</li>
              </ul>
            </div>
            <div class="chip-description" *ngIf="this.selectedCountry == 'Frankreich'">
              <ul>
                <li>Z1: {{result.badgeZ1}}</li>
                <li>Z2: {{result.badgeZ2}}</li>
                <li>Z3: {{result.badgeZ3}}</li>
                <li>Sw: {{result.sw}}</li>
                <li>TLw: {{result.tLw}}%</li>
              </ul>
            </div>
            <div class="chip-description" *ngIf="this.selectedCountry == 'Großbritannien'">
              <ul>
                <li>BFRC: {{result.wer}}</li>
                <li>Rating: {{result.rat}} </li>
              </ul>
            </div>
            <div class="chip-description" *ngIf="this.selectedCountry == 'Other'">
              <ul>
                <li>Ψ<sub>opak</sub>: {{result.psiOpaque}} W/mK<br>(Ψ<sub>g</sub>: {{result.psig}}) W/mK</li>
                <li>U<sub>w</sub> PHI: {{result.uwPhi  | number: '1.3-3'}} W/m²K<br>U<sub>g</sub>: {{result.ug  | number: '1.2-2'}} W/m²K</li>
                <li>{{'EFFICIENCY_CLASSES' | translate}}: {{result.effClass}} </li>
              </ul>
            </div>
          </div>
        </ion-label>
      </ion-chip>

      <div class="bordered-button" (click)="clickSeeDetails()" *ngIf="selectedCountry && result">
        <ion-icon name="eye-outline"></ion-icon>
        <span>{{'see_details' | translate}}</span>
      </div>
    </ng-container>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button class="next-btn" (click)="next()" expand="block">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>